<template>
    <div class="list_main">
        <div v-if="skipPic" class="skipPic">
            <img :src="skipPic" alt="">
        </div>
        <el-card v-else class="cardList carouselCard">
            <h1 style=" text-align: center">{{ title }}</h1>
            <div class="carouselContent carouselContent" v-html="content"></div>
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            title: '',
            content: '',
            skipPic: ''
        }
    },
    created() {
        if(this.$route.query.skipPic) {
            this.title = ''
            this.content = ''
            this.skipPic = this.$route.query.skipPic
        }else {
            this.skipPic = ''
            this.title = this.$route.query.title
            this.content = this.$route.query.content
        }

    }
}
</script>
<style lang="scss" scoped>
.list_main {
    display: flex;
    justify-content: center;
}
.carouselCard {
    display: flex;
    flex-flow: column;
    justify-content: center;
}
.carouselContent {
    width: 80%;
    margin: 50px auto;
}
.skipPic {
    width: 2000px;
    img {
        width: 100%;
    }
}
</style>